import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function Confirm(props) {
    const { title, description, okDisplay, cancelDisplay, onOk, onCancel, isVisible } = props;
    return (
        <>
        {
            isVisible &&
            <Dialog closeIcon={false} width={350} title={title}>
                <p>{description}</p>
                <DialogActionsBar>
                    <button onClick={onOk} className="k-button k-button-primary" aria-label="yes button of delete dialog">
                        {okDisplay}
                    </button>
                    <button onClick={onCancel} className="k-button" aria-label="no button of delete dialog">
                        {cancelDisplay}
                    </button>
                </DialogActionsBar>            
            </Dialog>
        }
        </>
    );

}